import axios from "axios"
//import store from "../store"

import {
    webApiDomain
} from "../utils/Constants"

const http = new axios.create({
    baseURL: webApiDomain
})

const httpMethod = {
    get(url, options = {}) {
        let vuex = JSON.parse(localStorage.getItem('soldoutt-nimda'))
        let accessToken = vuex.Auth.accessToken
        let header = {
            Authorization: `Bearer ${accessToken}`
        }
        return http
            .get(url, {
                ...options,
                headers: {
                    ...header,
                    ...options.headers
                }
            })
            .then(res => res.data)
            .then(data => {
                return data
            }).catch(err => {
                if (err.response.status == 401) {
                    //window.location = '/login?from=expire'
                }
                return Promise.reject(err.response.data)
            })
    },
    post(url, data = null, options = {}) {
        let vuex = JSON.parse(localStorage.getItem('soldoutt-nimda'))
        let accessToken = vuex.Auth.accessToken
        let header = {
            Authorization: `Bearer ${accessToken}`
        }
        return http
            .post(url, data, {
                ...options,
                headers: {
                    ...header,
                    ...options.headers
                }
            })
            .then(res => res.data)
            .then(data => {
                if (!data.success) {
                    if (data.is_verify === true || data.is_verify === false) {
                        const result = {
                            is_verify: data.is_verify
                        }
                        return result
                    }
                    return Promise.reject(data.error)
                }
                return data
            }).catch(err => {
                try{
                  if (err.response.status == 401) {
                      //window.location = '/login?from=expire'
                  }

                    return Promise.reject(err.response.data)
                }
                catch(_) {
                    return Promise.reject(err)
                }
            })
    },
    upload(url, formData = null, options = {}) {
        let vuex = JSON.parse(localStorage.getItem('soldoutt-nimda'))
        let accessToken = vuex.Auth.accessToken
        let header = {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'multipart/form-data'
        }
        return http
            .post(url, formData, {
                ...options,
                headers: {
                    ...header,
                    ...options.headers
                }
            })
            .then(res => res.data)
            .then(data => {
                if (!data.success) {
                    return Promise.reject(data.error)
                }

                return data
            }).catch(err => {
                if (err.response.status == 401) {
                    //window.location = '/login?from=expire'
                }
                return Promise.reject(err)
            })
    },
    create(url, data = null, options = {}) {

        let vuex = JSON.parse(localStorage.getItem('soldoutt-nimda'))
        let accessToken = vuex.Auth.accessToken
        let header = {
            Authorization: `Bearer ${accessToken}`
        }

        return http
            .post(url, data, {
                ...options,
                headers: {
                    ...header,
                    ...options.headers
                }
            })
            .then(res => res.data)
            .then(data => {
                if (!data.success) {
                    return Promise.reject(data.error)
                }
                return data
            }).catch(err => {
                if (err.response.status == 401) {
                    //window.location = '/login?from=expire'
                }
                return Promise.reject(err)
            })
    },
    put(url, data = null, options = {}) {

        let vuex = JSON.parse(localStorage.getItem('soldoutt-nimda'))
        let accessToken = vuex.Auth.accessToken
        let header = {
            Authorization: `Bearer ${accessToken}`
        }

        return http
            .put(url, data, {
                ...options,
                headers: {
                    ...header,
                    ...options.headers
                }
            })
            .then(res => res.data)
            .then(data => {
                if (!data.success) {
                    return Promise.reject(data.error)
                }
                return data
            }).catch(err => {
                if (err.response.status == 401) {
                    //window.location = '/login?from=expire'
                }
                return Promise.reject(err)
            })
    },
    delete(url, data = null, options = {}) {

        let vuex = JSON.parse(localStorage.getItem('soldoutt-nimda'))
        let accessToken = vuex.Auth.accessToken
        let header = {
            Authorization: `Bearer ${accessToken}`
        }
        return http
            .delete(url, data, {
                ...options,
                headers: {
                    ...header,
                    ...options.headers
                }
            })
            .then(res => res.data)
            .then(data => {
                if (!data.success) {
                    return Promise.reject(data.error)
                }
                return data
            }).catch(err => {
                if (err.response.status == 401) {
                    //window.location = '/login?from=expire'
                }
                return Promise.reject(err)
            })
    },

}
export default httpMethod
